const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Get all blogs with filters and pagination
const getBlogs = async (filters = {}) => {
  const { page, limit, status, category, isHidden, search } = filters;
  const token = localStorage.getItem('token');
  
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (limit) queryParams.append('limit', limit);
  if (status) queryParams.append('status', status);
  if (category) queryParams.append('category', category);
  if (isHidden !== undefined && isHidden !== '') {
    queryParams.append('isHidden', isHidden === 'true' ? true : false);
  }
  if (search) queryParams.append('search', search);

  const response = await fetch(`${API_URL}/api/v1/admin/blogs?${queryParams.toString()}`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Get blog by ID
const getBlogById = async (blogId) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs/${blogId}`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Get blog by slug
const getBlogBySlug = async (slug) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs/slug/${slug}`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Create a new blog
const createBlog = async (blogData) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs`, {
    method: 'POST',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(blogData)
  });
  return response.json();
};

// Update a blog
const updateBlog = async (blogId, blogData) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs/${blogId}`, {
    method: 'PUT',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(blogData)
  });
  return response.json();
};

// Delete a blog
const deleteBlog = async (blogId) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs/${blogId}`, {
    method: 'DELETE',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Hide/Unhide a blog
const toggleBlogVisibility = async (blogId, isHidden) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/blogs/${blogId}/hide`, {
    method: 'PATCH',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ isHidden })
  });
  return response.json();
};

export {
  getBlogs,
  getBlogById,
  getBlogBySlug,
  createBlog,
  updateBlog,
  deleteBlog,
  toggleBlogVisibility
};

